import { Divider } from "@mui/material";
import CollapseMenu from "./CollapseMenu";
import MenuItem from "./MenuItem";
import adminRoute from "../../../../Configurations/routes/AdminRoute";
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import uuid from "react-uuid";
import getAppRoutes from "../../../../Configurations/routes";

const DrawerList = ({ open, active, minSideNav }) => {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [routes, setRoutes] = useState([]);

  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const items = pathname.split("/").slice(1);
  const itemParentName = items[1];
  const itemName = items[items.length - 1];

  useEffect(() => {
    setOpenCollapse(collapseName);
  }, []);

  useEffect(() => {
    const appRoutes = getAppRoutes();
    console.log("App routes:", appRoutes);
    setRoutes(appRoutes || []);
  }, []);

  const _renderMenu = () => {
    // Use the routes from state instead of calling getAppRoutes() again
    if (!routes || !Array.isArray(routes) || routes.length === 0) {
      console.log("No routes available");
      return null;
    }
    
    let list = routes.map(({ type, name, title, key, icon, collapse }) => {
      // Handle section titles at top level
      if (type === "title") {
        return (
          <div
            key={key}
            style={{
              color: 'rgba(255, 255, 255, 0.5)',
              fontSize: '0.65rem',
              fontWeight: 'bold',
              textTransform: 'uppercase',
              paddingLeft: minSideNav ? '8px' : '16px',
              marginTop: '20px',
              marginBottom: '8px',
              letterSpacing: '0.5px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {!minSideNav && title}
          </div>
        );
      }

      if (type === "collapse") {
        return (
          <CollapseMenu
            key={uuid()}
            minSideNav={minSideNav}
            open={openCollapse === key}
            active={key === collapseName}
            name={name}
            icon={icon}
            onClick={() => (openCollapse === key ? setOpenCollapse(false) : setOpenCollapse(key))}
          >
            {collapse.map(({ type, name, title, key, route }) => {
              // Handle section title dividers
              if (type === "title") {
                return (
                  <div
                    key={key}
                    style={{
                      color: 'rgba(255, 255, 255, 0.6)',
                      fontSize: '0.65rem',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      paddingLeft: '24px',
                      marginTop: '16px',
                      marginBottom: '8px',
                      marginLeft: '8px',
                    }}
                  >
                    {title}
                  </div>
                );
              }

              // Handle regular menu items
              return (
                <NavLink to={route} key={key} style={{ textDecoration: "none" }}>
                  <MenuItem open={open} name={name} active={key === itemName} />
                </NavLink>
              );
            })}
          </CollapseMenu>
        );
      } else {
        return null;
        // <NavLink to={route} key={key} style={{ textDecoration: "none" }}>
        //   <MenuItem open={open} name={name} active={key === itemName} />
        // </NavLink>;
      }
    });

    return list;
  };

  return <>{_renderMenu()}</>;
};

export default DrawerList;
